import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

const fillArray = (count) => {
    const array = [];

    for (let i = 0; i < count; i++) {
        array.push([]);
    }
    return array;
};

class Hospital {
    static acceptRequest(props) {
        App.log('HOSPITAL.ACCEPT_REQUEST', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props?.sectionRequestId,
            patientBloodGroupId: parseInt(props?.patientBloodGroupId) || null
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.ACCEPT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(true);
                    },
                    '200:101': result => {
                        reject({message: result.resultMessage, result: result.objList});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static acceptRequestDelivery(props) {
        App.log('HOSPITAL.ACCEPT_REQUEST_DELIVERY', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props?.hospitalRequestId,
            statusId: 1
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.REQUEST_DELIVERY_PRODUCTS.ACCEPT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(true);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static acceptedRequestList() {
        App.log('HOSPITAL.ACCEPTED_REQUEST_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.ACCEPTED_LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static cancelCrossMatch(props) {
        App.log('HOSPITAL.CANCEL_CROSS_MATCH', App.LOG.FETCH, props);

        const body = {
            crossMatchId: props.crossMatchId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.CROSS_MATCH.CANCEL, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }

    static cancelIncompatible(props) {
        App.log('HOSPITAL.CANCEL_INCOMPATIBLE', App.LOG.FETCH, props);

        const body = {
            incompatibleId: props.incompatibleId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.INCOMPATIBLE.DELETE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }

    static cancelReserve(props) {
        App.log('HOSPITAL.CANCEL_RESERVE', App.LOG.FETCH, props);

        const body = {
            reserveId: props.reserveId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.RESERVE.CANCEL, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }

    static cancelSentProduct(props) {
        App.log('HOSPITAL.CANCEL_SENT_PRODUCT', App.LOG.FETCH, props);

        const body = {
            outcomingDetailId: props.outcomingDetailId,
            cancelOutgoingType: props.cancelOutgoingType,
            sectionReturnReasonId: parseInt(props.sectionReturnReasonId),
            destroyedReasonId: parseInt(props.destroyedReasonId)
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.DELIVER.CANCEL, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static confirmProductInDelivery(props) {
        App.log('HOSPITAL.CONFIRM_PRODUCT_IN_DELIVERY', App.LOG.FETCH, props);

        const body = {
            orgProductId: props?.orgProductId,
            statusId: 2,
            cellTypeTest: false
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.REQUEST_DELIVERY_PRODUCTS.ACCEPT_OR_DENY_PRODUCT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(true);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static crossMatch(props) {
        App.log('HOSPITAL.CROSS_MATCH', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId,
            productId: props.productId,
            plasmaDetail: props.plasmaDetail,
            bloodDetail: props.bloodDetail,
            securityInfo: props.securityInfo
        };
        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.CROSS_MATCH.SUBMIT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static crossMatchData(props) {
        App.log('HOSPITAL.CROSS_MATCH_DATA', App.LOG.FETCH, props);

        const body = {
            patientFileCodeId: props.patientFileCodeId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.CROSS_MATCH.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static deliverProduct(props) {
        App.log('HOSPITAL.DELIVER_PRODUCT', App.LOG.FETCH, props);

        const body = {
            crossMatchList: props.crossMatchList.map(item => {
                return {
                    crossMatchId: item.crossMatchId,
                    productId: item.productId,
                    productNumber: item.productNumber
                };
            }),
            sectionId: parseInt(props.sectionId),
            receiverUserId: null,
            receiverUserStr: props.receiverUserStr
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.DELIVER.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static destroyedList() {
        App.log('HOSPITAL.DESTROYED_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.DESTROYED, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static getDeliveryData(props) {
        App.log('HOSPITAL.GET_DELIVERY_DATA', App.LOG.FETCH, props);

        const body = {
            outcomingId: props.outcomingId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.DELIVER.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static incomingList(props = {}) {
        App.log('HOSPITAL.INCOMING_LIST', App.LOG.FETCH, props);

        const body = {
            productId: props.productId || null,
            productNumber: props.productNumber || null,
            bloodGroupId: props.bloodGroupId || null,
            productTypeId: props.productTypeId || null
        };

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.INCOMING, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static incompatible(props) {
        App.log('HOSPITAL.INCOMPATIBLE', App.LOG.FETCH, props);

        const body = {
            productId: props.productId,
            fileCodeId: props.fileCodeId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.INCOMPATIBLE.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static incompatibleList(props) {
        App.log('HOSPITAL.INCOMPATIBLE_LIST', App.LOG.FETCH, props);

        const body = {
            fileCodeId: props.fileCodeId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.INCOMPATIBLE.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static inventory() {
        App.log('HOSPITAL.INCOMING_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.INVENTORY, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        const list = result?.objList;

                        let productTypes = {};
                        let bloodGroups = {};

                        for (const item of list) {
                            //if productType is new one
                            if (!productTypes[item.productTypeId])
                                productTypes[item.productTypeId] = {
                                    // index: Object.keys(productTypes).length,
                                    id: item.productTypeId,
                                    shortName: item.productTypeShortNameStr,
                                    name: item.productTypeStr
                                };

                            //if bloodGroup is new one
                            if (!bloodGroups[item.bloodGroupId])
                                bloodGroups[item.bloodGroupId] = {
                                    // index: Object.keys(bloodGroups).length,
                                    id: item.bloodGroupId,
                                    shortName: item.bloodGroupShortNameStr,
                                    name: item.bloodGroupStr
                                };
                        }

                        productTypes = Object.values(productTypes);
                        bloodGroups = Object.values(bloodGroups);
                        const productTypeList = fillArray(productTypes.length);
                        const bloodGroupList = fillArray(bloodGroups.length);

                        for (let item of list) {
                            const bIndex = bloodGroups.findIndex(b => b.id === item.bloodGroupId);
                            const pIndex = productTypes.findIndex(p => p.id === item.productTypeId);

                            bloodGroupList[bIndex][pIndex] = item;
                            productTypeList[pIndex][bIndex] = item;
                        }

                        for (let b = 0; b < bloodGroups.length; b++) {
                            for (let p = 0; p < productTypes.length; p++) {
                                if (!bloodGroupList[b][p]) {
                                    bloodGroupList[b][p] = {
                                        bloodGroupId: bloodGroups[b].id,
                                        bloodGroupShortNameStr: bloodGroups[b].shortName,
                                        bloodGroupStr: bloodGroups[b].name,
                                        hospitalFullName: null,
                                        hospitalId: null,
                                        hospitalShortName: null,
                                        isProductReduce: null,
                                        minStorageAmount: null,
                                        inventory: 0,
                                        productTypeId: productTypes[p].id,
                                        productTypeShortNameStr: productTypes[p].shortName,
                                        productTypeStr: productTypes[p].name,
                                    };
                                }
                                if (!productTypeList[p][b]) {
                                    productTypeList[p][b] = {
                                        bloodGroupId: bloodGroups[b].id,
                                        bloodGroupShortNameStr: bloodGroups[b].shortName,
                                        bloodGroupStr: bloodGroups[b].name,
                                        hospitalFullName: null,
                                        hospitalId: null,
                                        hospitalShortName: null,
                                        isProductReduce: null,
                                        minStorageAmount: null,
                                        inventory: 0,
                                        productTypeId: productTypes[p].id,
                                        productTypeShortNameStr: productTypes[p].shortName,
                                        productTypeStr: productTypes[p].name
                                    };
                                }
                            }
                        }

                        resolve({raw: list, bloodGroups, productTypes, bloodGroupList, productTypeList});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static miniStatistic(props) {
        App.log('HOSPITAL.MINI_STATISTIC', App.LOG.FETCH, props);

        const body = {
            startDate: props.startDate,
            endDate: props.endDate
        };

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.MINI_STATISTIC, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static orgRequestList() {
        App.log('HOSPITAL.ORG_REQUEST_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.ORG_NORM.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static outgoingList() {
        App.log('HOSPITAL.OUTGOING_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.OUTGOING, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static productListForReserve() {
        App.log('HOSPITAL.PRODUCT_LIST_FOR_RESERVE', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.INCOMING_FOR_RESERVE, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static readyList() {
        App.log('HOSPITAL.READY_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.READY, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static receiveRequest(props) {
        App.log('HOSPITAL.RECEIVE_REQUEST', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.RECEIVE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static rejectProductInDelivery(props) {
        App.log('HOSPITAL.DENY_PRODUCT_IN_DELIVERY', App.LOG.FETCH, props);

        const body = {
            orgProductId: props?.orgProductId,
            statusId: 3
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.REQUEST_DELIVERY_PRODUCTS.ACCEPT_OR_DENY_PRODUCT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(true);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static rejectRequest(props) {
        App.log('HOSPITAL.REJECT_REQUEST', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId,
            statusId: 22
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.UPDATE_STATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static requestDeliveryProducts(props) {
        App.log('HOSPITAL.REQUEST_DELIVERY_PRODUCTS', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props?.hospitalRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.REQUEST_DELIVERY_PRODUCTS.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static requestList() {
        App.log('HOSPITAL.REQUEST_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.REQUEST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static reserve(props) {
        App.log('HOSPITAL.RESERVE', App.LOG.FETCH, props);

        const body = {
            bloodGroupId: props.bloodGroupId,
            productTypeId: props.productTypeId,
            sectionRequestId: props.sectionRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.RESERVE.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.SUBMIT_FAILED);
            });
        });
    }

    static reserveList(props) {
        App.log('HOSPITAL.RESERVE_LIST', App.LOG.FETCH, props);

        const body = {
            patientFileCodeId: props?.patientFileCodeId || null
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.RESERVE.LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static reserveLogs(props) {
        App.log('HOSPITAL.RESERVE_LOGS', App.LOG.FETCH, props);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.RESERVE_LOGS, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static returnToHospitalList() {
        App.log('HOSPITAL.RETURN_TO_HOSPITAL_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.RETURN_TO_HOSPITAL, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static returnToOrgList() {
        App.log('HOSPITAL.RETURN_TO_ORG_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.RETURN_TO_ORG, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static sectionReceiverList(props) {
        App.log('HOSPITAL.SECTION_RECEIVER_LIST', App.LOG.FETCH, props);

        const body = {
            sectionId:props.sectionId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.HOSPITAL.LIST.RECEIVER_LIST, {
                body:JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers(),
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

export default Hospital;